"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationDialog = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var react_intl_1 = require("react-intl");
var core_1 = require("@material-ui/core");
var styled_components_1 = __importDefault(require("styled-components"));
var StyledCircularProgress = core_1.withTheme(styled_components_1.default(core_1.CircularProgress)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        width: 20px !important;\n        height: 20px !important;\n    "], ["\n        width: 20px !important;\n        height: 20px !important;\n    "]))));
exports.ConfirmationDialog = function (props) {
    var confirmButtonText = props.confirmButtonText, onConfirm = props.onConfirm, onCancel = props.onCancel, open = props.open, _a = props.title, title = _a === void 0 ? react_1.default.createElement(react_intl_1.FormattedMessage, { id: "confirmDecisionTitle" }) : _a, message = props.message, other = __rest(props, ["confirmButtonText", "onConfirm", "onCancel", "open", "title", "message"]);
    var _b = react_1.useState(false), isSending = _b[0], setIsSending = _b[1];
    var startIcon = isSending && react_1.default.createElement(StyledCircularProgress, null);
    var handleCancel = function () {
        onCancel();
    };
    var handleOk = function () {
        setIsSending(true);
        onConfirm().finally(stopIsSending);
    };
    var stopIsSending = function () {
        setIsSending(false);
    };
    return (react_1.default.createElement(core_1.Portal, null,
        react_1.default.createElement(Dialog_1.default, __assign({ fullWidth: true, maxWidth: "xs", "aria-labelledby": "confirmation-dialog-title", transitionDuration: 0, open: open }, other),
            react_1.default.createElement(DialogTitle_1.default, { id: "confirmation-dialog-title" }, title),
            message && react_1.default.createElement(DialogContent_1.default, null, message),
            react_1.default.createElement(DialogActions_1.default, null,
                react_1.default.createElement(Button_1.default, { autoFocus: true, onClick: handleCancel, color: "primary" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "cancelButton" })),
                react_1.default.createElement(Button_1.default, { onClick: handleOk, color: "secondary", variant: "contained", disabled: isSending, startIcon: startIcon }, confirmButtonText || react_1.default.createElement(react_intl_1.FormattedMessage, { id: "confirmButton" }))))));
};
var templateObject_1;
